import { useState } from 'react';
import styled  from 'styled-components';
import { breakpoints } from '@/layouts/breakpoints'
import LazyVideo from '@/components/landing/common/LazyVideo'
import Trackx from '@/components/landing/common/Tracx';

const useCasesContent = [
    {vid: 'https://cdn.studio14a.com/axion/uc/1.mp4', vc: '', title: "FOR THE DEEP-DIVE RESEARCHER", copy: "Move beyond surface-level SEC filings. Axion's SEC filings API and investment research tools give you the interconnected intelligence to build a bullet-proof thesis. Correlate credit rating shifts with sentiment analysis, map supply chain dependencies, and track web traffic for early growth signals. Discover the hidden catalysts and risks others miss."},
    {vid: 'https://cdn.studio14a.com/axion/uc/3.mp4', vc: '', title: "BUILD MORE ROBUST FINANCIAL MODELS", copy: "Feed your DCFs, LBOs, and scenario analyses with more predictive variables. Integrate fundamental data, clean, normalized ESG scores, supplier health data, and sector-wide sentiment directly into your spreadsheets. Enhance forecast accuracy by quantifying intangible factors that move markets."},
    {vid: 'https://cdn.studio14a.com/axion/uc/4.mp4', vc: 'up', title: "TRAIN SMARTER, MORE PREDICTIVE MODELS", copy: "Your algorithms are only as good as your data. Access a vast, structured universe of alpha signals through a single market data API, from alternative datasets to global asset pricing. Perfect for feature engineering, backtesting complex strategies, and discovering non-obvious relationships across equities, crypto, and forex."},
    {vid: 'https://cdn.studio14a.com/axion/uc/2.mp4', vc: 'smallup', title: "THE INSTITUTIONAL EDGE, SCALED", copy: "Empower every trader with institutional-grade data without the institutional cost. From daily and hourly data for systematic strategies to decades of historical market data for strategy validation, Axion provides the institutional financial data API your firm needs to identify, test, and scale edges efficiently."},
    {vid: 'https://cdn.studio14a.com/axion/uc/5.mp4', vc: '',  title: "TRADE WITH THE CONFIDENCE OF A PRO", copy: "Level the playing field. Access the same type of alternative data that funds use, including sentiment, supply chain insights, and on-chain metrics, delivered through one intuitive financial data API. Make informed decisions, validate your hunches with stock market data, and build a more professional approach to the markets."},
  ]

// Single source of truth for timing so the video and copy stay in lockstep.
// A symmetric sine ease-in-out - slow start, slow end - rather than a
// "decelerate" curve, which front-loads the opacity change and reads as a
// fast pop followed by a slow crawl.
const FADE_MS = 400;
const FADE_EASING = 'cubic-bezier(0.37, 0, 0.63, 1)';

const StyledComp = styled.div`
  padding: 40px 0;
  position: relative;
  z-index: 9;
  background-color: white;

  @media (max-width: ${breakpoints.medium}) {
    padding: 20px 0;
    padding-top: 40px;
  }

  .text{
    padding: 10px 40px;
    border-top: 1px solid rgba(var(--greyr), 0.3);
    border-bottom: 1px solid rgba(var(--greyr), 0.3);

    @media (max-width: ${breakpoints.medium}) {
      padding: 10px 20px;
    }

    h2{
      padding: 20px 0;
    }
    p{
      color: var(--grey);
      padding-bottom: 20px;
    }
  }
  .tabs{
    display: flex;
    flex-direction: row;
    gap: 40px;
    padding: 40px;
    border-bottom: 1px solid rgba(var(--greyr), 0.3);
    overflow-x: auto;

    @media (max-width: ${breakpoints.medium}) {
      padding: 20px;
      gap: 20px;
    }

    .tab{
      cursor: pointer;
      white-space: nowrap;
      opacity: 0.7;
      transition-duration: 0.3s;
        border-bottom: 1px solid white;
      &.active{
        border-color: var(--black);
        opacity: 1;
      }

      &:hover{
        opacity: 1;
        border-color: rgba(0, 0, 0, 0.4);
      }
    }
  }
  .display{
    width: 100%;
    height: 60vh;
    display: flex;
    flex-direction: row;
    border-bottom: 1px solid rgba(var(--greyr), 0.3);

    @media (max-width: ${breakpoints.large}) {
      flex-direction: column;
      height: auto;
    }

    .content{
      padding: 40px;
      text-align: right;
      margin-left: 40vw;
      transition: opacity ${FADE_MS}ms ${FADE_EASING};

      &.fade-out { opacity: 0; }
      &.fade-in  { opacity: 1; }

      @media (max-width: ${breakpoints.large}) {
        text-align: left;
        padding: 20px;
        padding-top: 80px;
        margin-left: 20px;
        width: calc(100vw - 40px);
      }

      @media (max-width: ${breakpoints.large}) {
        width: calc(100% - 80px);
          min-height: 50vh;
        overflow: hidden;
      }
      p{
        color: var(--grey);
        padding: 40px 0;
        width: 70%;
        margin-left: 30%;
        line-height: 1.6;

        @media (max-width: ${breakpoints.large}) {
          width: 60%;
          margin-left: 0;
        }
        @media (max-width: ${breakpoints.small}) {
          width: 100%;
        }
      }
      h3{
        font-size: 32px;

        @media (max-width: ${breakpoints.medium}) {
          font-size: 28px;
        }
      }
    }

    .graphic{
      position: absolute;
      z-index: -1;
      width: 100vw;
      overflow-x: hidden;

      @media (max-width: ${breakpoints.large}) {
        border-right: none;
        min-height: 300px;
    }

      .video{
          transition: all ${FADE_MS}ms ${FADE_EASING}!important;
          transition-duration: ${FADE_MS}ms!important;
          transition-delay: 300ms!important;

          &.fade-out {
            opacity: 0!important;
            transition-duration: ${FADE_MS}ms!important;
          }

          &.fade-in {
            opacity: 1!important;
            transition-duration: ${FADE_MS}ms!important;
          }

      }
      video{
        position: relative;
        top: 0%;
        left: 0;
        min-width: 100%;
        width: auto;
        height: 100%;
        // object-fit: cover;

        &.up{
          transform: translateY(-15%);
        }
         &.smallup{
          transform: translateY(-10%);
        }
      }


    }

  }

`;

const Comp = ({}) => {
  const [dithIndex, setDithIndex] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);

  const handleTabClick = (newIndex) => {
    if (newIndex === dithIndex || isTransitioning) return;

    setIsTransitioning(true);

    setTimeout(() => {
      setDithIndex(newIndex);

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          setIsTransitioning(false);
        });
      });

    }, FADE_MS + 350);
  };

  return (
    <StyledComp>
      <div className="text">
        <h2 className="serif"> A Complete Financial Data API </h2>
        <p>One platform to collect, normalize, and activate smarter financial signals across every market. </p>
      </div>

      <div className="display">
        <div className="graphic">
          <LazyVideo
            classNames={`video ${isTransitioning ? 'fade-out' : 'fade-in'} ${useCasesContent[dithIndex].vc}`}
            src={useCasesContent[dithIndex].vid}
            key={dithIndex}
          />
        </div>

        <div className={`content ${isTransitioning ? 'fade-out' : 'fade-in'}`}>

          <h3 className="sans"> {useCasesContent[dithIndex].title} </h3>
          <p> {useCasesContent[dithIndex].copy} </p>
        </div>

      </div>

      <Trackx>
        <div className="tabs">
          {
            ['Analysts', 'Modeling', 'Machine Learning', 'Prop Firms', 'Retail'].map((tab, i) => (
              <div className={dithIndex === i ? 'tab active' : 'tab'} key={i} onClick={() => handleTabClick(i)} > {tab}</div>
            ))

          }
        </div>
      </Trackx>
    </StyledComp>  );
};

export default Comp;
